<template>
    <!--
        IMPORTANT NOTE 
        ==============
        This component is being used on both View and CI.
        So this file is handling logics based on its referer.
        Please be careful if you want to change anything in this file
        and make sure you test on both View and CI before deploy.
    -->
    <v-select
        ref="select"
        v-model="selectedAppointment"
        class="style-chooser-schedule"
        @search="fetchAppointments"
        @input="submit"
        :placeholder="placeholder"
        :noDrop="isDisableDrop"
        :options="options"
        :disabled="isDisabled"
        :class="{
            search: true,
            'nav-search': true,
            appointments: true,
            ci: isCI
        }"
    >
        <template v-slot:option="{ label }">
            <b>{{ label }}</b>
        </template>
    </v-select>
</template>

<script>
import vSelect from "vue-select";
import { debounce } from "lodash";
import axios from "axios";

export default {
    components: {
        vSelect
    },
    props: {
        placeholder: {
            type: String,
            default: "Search appointments"
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        focusOnload: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            selectedAppointment: "",
            isDisableDrop: true,
            options: []
        };
    },
    computed: {
        isCI() {
            return this.$root.referer === "CI";
        }
    },
    watch: {
        options(options = []) {
            let maxLength = 0;
            let ul = document.querySelector(".search.appointments ul");

            if (options.length === 0) {
                ul.style.width = "";
                ul.style.left = "";
                ul.style.right = "";
                ul.style.borderTopLeftRadius = "";
                ul.style.borderTopRightRadius = "";
            } else {
                for (let option of options) {
                    let nameLength = option.label.length;

                    if (nameLength > maxLength) {
                        maxLength = nameLength;
                    }
                }

                ul.style.width = `${maxLength * 10}px`;
                ul.style.left = "unset";
                ul.style.right = "0";
                ul.style.borderTopLeftRadius = "5px";
                ul.style.borderTopRightRadius = "5px";
            }
        }
    },
    mounted() {
        if (this.focusOnload) {
            this.$refs.select.$el.querySelector("input").focus();
        }
    },
    methods: {
        submit(value) {
            if (!value || value === "") {
                return;
            }

            if (this.isCI) {
                window.census_model.init(
                    value.dateMoment.format(my_date_format_for_moment)
                );
            } else {
                this.$emit("onselect", value);
            }

            this.selectedAppointment = "";
            this.options = [];
        },
        fetchAppointments(search) {
            if (search === "" || search.length < 3) {
                this.options = [];
                this.isDisableDrop = true;
            } else {
                this.searchAppointments(search, this);
            }
        },
        properList(raw = []) {
            let result = [];

            for (const option of raw) {
                const {
                    id,
                    start: dateStart,
                    reason,
                    patient_name,
                    client_firstname,
                    client_lastname
                } = option;

                let isDuplicatedId = result.find(r => r.id === id);
                let dateLabel;
                let dateMoment;
                let momentRawDateFormat = "YYYY-MM-DD HH:mm";
                let timezone = this.isCI ? my_time_zone : this._timeZone;

                if (isDuplicatedId) {
                    continue; // skip process if id is already in the list
                }

                // prettier-ignore
                if (["UTC", "GMT"].includes(dateStart.timezone)) {
                    dateMoment = moment.utc(dateStart.date, momentRawDateFormat).tz(timezone);
                } else {
                    dateMoment = moment(dateStart.date, momentRawDateFormat).tz(timezone);
                }

                // date label
                // prettier-ignore
                if (this.isCI) {
                    dateLabel = dateMoment.format(my_date_format_for_moment + " HH:mm A");
                } else {
                    dateLabel = this._carbonDateTimeDisplay(dateStart);
                }

                let label = `${dateLabel} - ${reason} for ${patient_name} (${client_lastname}, ${client_firstname})`;

                result.push({
                    id: option.id,
                    label: label,
                    date: dateStart,
                    dateMoment: dateMoment
                });
            }

            return result;
        },
        searchAppointments: debounce(async (search, self) => {
            const res = await axios.post(
                `${process.env.BARRAMUNDI}schedule/appointment/search`,
                { query: search }
            );

            const { message, resource } = res.data.response;

            if (message.code === 200) {
                self.options = self.properList(resource);
                self.isDisableDrop = false;
            } else {
                self.options = [];
                self.isDisableDrop = true;
            }
        }, 350)
    }
};
</script>
<style>
.style-chooser-schedule .vs__dropdown-menu {
    max-width: 50vw !important;
}
.style-chooser-schedule .vs__dropdown-menu li {
    white-space: normal;
    word-wrap: break-word;
}
</style>
